import { __decorate } from "tslib";
import { customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import styles from './NavigationDrawerSection.styles.scss';
const template = html `<template tabindex="-1">
  <chameleon-typography variant="caption-medium-strong" tag="h2"><slot></slot></chameleon-typography
  ><slot name="end"></slot>
</template>`;
export const navigationDrawerSectionDefinition = {
    name: 'chameleon-navigation-drawer-section',
    template,
    styles,
};
let NavigationDrawerSectionComponent = class NavigationDrawerSectionComponent extends ChameleonElementMixin(FASTElement) {
};
NavigationDrawerSectionComponent = __decorate([
    customElement(navigationDrawerSectionDefinition)
], NavigationDrawerSectionComponent);
export { NavigationDrawerSectionComponent };
